import { Controller } from "@hotwired/stimulus"
import RequestHelper from "../helpers/request_helper"

// Paired with the shared `datatable` controller on the same wrapping element: that one owns the
// DataTables lifecycle, this one owns the undebounced name filter and the per-row add/remove
// toggle.
//
// GalleryDecorator#preview_datatable_actions writes the row button's own `data-action`, so
// Stimulus's mutation observer rewires it on every ajax redraw the same way it would a Turbo
// Stream insert -- no manual delegation needed.
export default class extends Controller {
  static get targets() {
    return ["table"];
  }

  // Undebounced: every keystroke fires its own server-side search. Long-standing behaviour on
  // this page, not an oversight.
  search(event) {
    $(this.tableTarget).DataTable().search(event.target.value).draw();
  }

  // A failed request leaves the button's class, text and data attributes untouched; only the
  // success branch mutates them.
  onRowButtonClick(event) {
    const button = event.currentTarget;
    const method = (button.dataset.method || "").toLowerCase();
    const options = method === "delete" ? RequestHelper.defaultDeleteOptions() : RequestHelper.defaultPostOptions();

    // Both target actions branch on `respond_to`, so the XHR header pair is required for them to
    // answer with JSON rather than a redirect.
    options.headers = Object.assign({}, options.headers, {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
      "Accept": "application/json, text/plain, */*",
    });
    // `.dataset` never coerces, unlike jQuery's `.data()` -- gallery_id is a numeric id, so
    // coerce explicitly to keep the JSON payload shape identical to what the server expects.
    options.body = JSON.stringify({ galleries_preview: { gallery_id: Number(button.dataset.galleryId) } });

    fetch(button.dataset.url, options).then((response) => {
      if (!response.ok) {
        response.text().then((message) => this.onRowButtonError(message));
        return;
      }

      response.json().then((data) => this.onRowButtonSuccess(button, data, response.status));
    });
  }

  onRowButtonSuccess(button, data, status) {
    let verb;
    if (status === 201) {
      button.classList.remove("btn-primary");
      button.textContent = "-";
      button.dataset.method = "delete";
      button.dataset.url = data.url;
      verb = "added";
    } else {
      button.classList.add("btn-primary");
      button.textContent = "+";
      button.dataset.method = "post";
      button.dataset.url = data.url;
      verb = "removed";
    }

    window.ltAlert({
      message: `${data.gallery_name} has been ${verb}.`,
      type: "toast-success",
      duration: 1500,
      lasso: false,
      showMultiple: true,
    });
  }

  onRowButtonError(message) {
    console.warn(message);

    window.ltAlert({
      message: message.split("\n").slice(0, 5).join("\n"),
      type: "toast-error",
      duration: 0,
      lasso: false,
      escapeMarkup: false,
    });
  }
}
